const TabOptions = {
    activeClass: "active",
    inactiveClass: "",
};
const Default = {
    activeClasses: "active",
    inactiveClasses: "inactive",
};
class Tabs {
    constructor(tabsEl, items, options) {
        this._tabsEl = tabsEl;
        this._options = Object.assign(Object.assign({}, TabOptions), options);
        this._activeTab = null;
        this._items = items;
        this._initialized = false;
        this._init();
    }
    _init() {
        if (this._items.length && !this._initialized) {
            // set the first tab as active if not set by explicitly
            if (!this._activeTab) {
                this.setActiveTab(this._items[0]);
            }
            // force show the first default tab
            if (this._activeTab) {
                this.show(this._activeTab.id, true);
            }
            // show tab content based on click
            this._items.map((tab) => {
                tab.triggerEl.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.show(tab.id);
                });
            });
        }
    }
    setActiveTab(tab) {
        this._activeTab = tab;
    }
    getTab(id) {
        return this._items.filter((t) => t.id === id)[0];
    }
    show(id, forceShow = false) {
        const tab = this.getTab(id);
        // don't do anything if already active
        if (tab === this._activeTab && !forceShow) {
            return;
        }
        // hide other tabs
        this._items.map((t) => {
            if (t !== tab) {
                t.triggerEl.classList.remove(...this._options.activeClasses.split(" "));
                t.triggerEl.classList.add(...this._options.inactiveClasses.split(" "));
                t.targetEl.classList.add("hidden");
                t.triggerEl.setAttribute("aria-selected", "false");
            }
        });
        // show active tab
        tab.triggerEl.classList.add(...this._options.activeClasses.split(" "));
        tab.triggerEl.classList.remove(...this._options.inactiveClasses.split(" "));
        tab.triggerEl.setAttribute("aria-selected", "true");
        tab.targetEl.classList.remove("hidden");
        this.setActiveTab(tab);
    }
}
function initTabs() {
    document.querySelectorAll("[data-tabs-toggle]").forEach(($parentEl) => {
        const tabItems = [];
        const activeClasses = $parentEl.getAttribute("data-active-classes");
        const inactiveClasses = $parentEl.getAttribute("data-inactive-classes");
        let defaultTabId = null;
        $parentEl.querySelectorAll('[role="tab"]').forEach(($triggerEl) => {
            const isActive = $triggerEl.getAttribute("aria-selected") === "true";
            const targetId = $triggerEl.getAttribute("data-tabs-target");
            if (!targetId) {
                console.error("Tab trigger element is missing data-tabs-target attribute");
                return;
            }
            const $targetEl = document.querySelector(targetId);
            if (!$targetEl) {
                console.error(`Tab target element with id ${targetId} does not exist in the DOM`);
                return;
            }
            const tab = {
                id: $triggerEl.getAttribute("data-tabs-target"),
                triggerEl: $triggerEl,
                targetEl: $targetEl,
            };
            tabItems.push(tab);
            if (isActive) {
                defaultTabId = tab.id;
            }
        });
        new Tabs($parentEl, tabItems, {
            defaultTabId: defaultTabId,
            activeClasses: activeClasses ? activeClasses : Default.activeClasses,
            inactiveClasses: inactiveClasses
                ? inactiveClasses
                : Default.inactiveClasses,
        });
    });
}
export { initTabs, Tabs };
